import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AppErrorBoundary, darfStillNeuLaden } from "./ui/ErrorBoundary";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root nicht gefunden");

/**
 * STAGING-Banner (Audit 2026-07-19; Layout-Fix 2026-07-19): Auf der Staging-Umgebung liegt
 * oben ein fester Warnstreifen. Damit er den App-Kopf (sticky Header) und die fixe Sidebar
 * NICHT ueberdeckt, sondern die App nach unten schiebt, setzt die Klasse `staging-env` am
 * <body> die Layout-Regeln in index.css (padding-top + top-Offset fuer die fixed/sticky-Chrome).
 * Aktiv nur, wenn der staging-deploy-Build VITE_ENVIRONMENT="staging" setzt — im Prod-Build
 * existiert weder die Klasse noch der Streifen (tree-shakebar, kein Overhead).
 */
// Nach einem Deploy fehlen die alten, nachladbaren Chunks: Vite meldet das als `vite:preloadError`.
// Einmal still neu laden (Schleifenschutz 30 s), sonst greift die Fehler-Ansicht.
window.addEventListener("vite:preloadError", (e) => {
  if (!darfStillNeuLaden()) return;
  e.preventDefault();
  window.location.reload();
});

const isStagingBuild = import.meta.env.VITE_ENVIRONMENT === "staging";
if (isStagingBuild) document.body.classList.add("staging-env");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    {isStagingBuild && (
      <div className="staging-banner" role="status" aria-label="Staging-Testsystem">
        ⚠ STAGING — TESTSYSTEM · KEINE ECHTEN MAILS / ZAHLUNGEN / RECHNUNGEN
      </div>
    )}
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
